import { Navigate } from 'react-router-dom'

const AdminPosts = () => <Navigate to="/admin?section=posts" replace />

export default AdminPosts
